
import React from 'react';
import './OpsPage.css';
import SubTabBar, { SubTab } from '../../components/shared/SubTabBar';
import { useAppState, OpsTab } from '../../context/AppStateContext';
import SystemMonitorPage from '../system-monitor/SystemMonitorPage';
import FilesPage from '../files/FilesPage';
import DatabasePage from '../database/DatabasePage';
import IntegrationsPage from '../integrations/IntegrationsPage';

const TABS: SubTab<OpsTab>[] = [
  { id: 'monitor', label: 'Monitor', icon: 'monitor' },
  { id: 'files', label: 'Files', icon: 'files' },
  { id: 'database', label: 'Database', icon: 'database' },
  { id: 'integrations', label: 'Integrations', icon: 'integrations' },
];

export default function OpsPage() {
  const { appState, setAppState } = useAppState();

  const renderTab = () => {
    switch (appState.opsTab) {
      case 'monitor': return <SystemMonitorPage />;
      case 'files': return <FilesPage />;
      case 'database': return <DatabasePage />;
      case 'integrations': return <IntegrationsPage />;
      default: return <SystemMonitorPage />;
    }
  };

  return (
    <div className="ops-page">
      <SubTabBar
        tabs={TABS}
        active={appState.opsTab}
        onChange={tab => setAppState(s => ({ ...s, opsTab: tab }))}
      />
      <div className="ops-page__content">
        {renderTab()}
      </div>
    </div>
  );
}
